import { useUser } from "../../../../store/session/hooks";
import { useMeetingSelector, useMultiMeetingAPI } from "../../../../hooks/meeting";
import { useStudentContext } from "../context";
import { PedagogyStudentContainer } from "../../../../components/pedagogy/student/PedagogyStudentContainer";

export const MeetingPedagogyStudentPage = () => {
  const user = useUser();

  const studentCtx = useStudentContext();

  const multiMeetingAPI = useMultiMeetingAPI();
  const pedaMeetingAPI = multiMeetingAPI?.pedagogy?.container?.getAPI();

  const [pedaMeeting] = useMeetingSelector(pedaMeetingAPI, (state) => state.meeting);

  if (!studentCtx || !pedaMeeting || !user) {
    return null; // impossible
  }

  const { populatedMeetingData, currentView } = studentCtx;

  if (!populatedMeetingData || !currentView) {
    return null; // impossible
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <PedagogyStudentContainer
        meeting={pedaMeeting}
        populatedMeeting={populatedMeetingData}
        view={currentView}
        layout={studentCtx.layout}
        selfVideoStream={studentCtx.selfVideoStream}
      />
    </div>
  );
}
